import { useQuery } from 'react-query';
import hash from 'object-hash';
const baseRoute = process.env.REACT_APP_BASE_URL;
import { UserType } from '../types/types';

async function addHnosApiCall(params?: string[] | null, user?: UserType | null) {
  if (!user?.token) return null;
  if (params === null || !params?.length) return null;
  const headers = {
    'Content-Type': 'application/json',
    'Authorization': `Bearer ${user.token}`,
  };
  const response = await fetch(
    `${baseRoute}/api/alumnos/hermanos`,
    { headers, body: JSON.stringify(params), method: 'POST' },
  );
  if (!response.ok) {
    throw new Error('Problem fetching data');
  }
  const resp = await response.json();
  return resp as boolean;
}

async function getHnosApiCall(id?: string | null, user?: UserType | null) {
  if (!user?.token || !id) return null;
  const headers = {
    'Authorization': `Bearer ${user.token}`,
  };
  const response = await fetch(
    `${baseRoute}/api/alumnos/hermanos?id=${id}`,
    { headers, method: 'GET' },
  );
  if (!response.ok) {
    throw new Error('Problem fetching data');
  }
  const resp = await response.json();
  return resp as string[];
}

async function removeHnosApiCall(id?: string | null, user?: UserType | null) {
  if (!user?.token || !id) return null;
  const headers = {
    'Authorization': `Bearer ${user.token}`,
  };
  const response = await fetch(
    `${baseRoute}/api/alumnos/hermanos?id=${id}`,
    { headers, method: 'DELETE' },
  );
  if (!response.ok) {
    throw new Error('Problem fetching data');
  }
  const resp = await response.json();
  return resp as boolean;
}

export function UseAddHnos(params:string[] | null, user?: UserType | null) {
  return useQuery<boolean | null, Error>(
    ['addHnos', hash(params ?? ''), hash(user ?? '')],
    () => addHnosApiCall(params, user), {
      cacheTime: 3600,
      refetchOnWindowFocus: false,
    },
  );
}
export function UseGetHnos(params?:string | null, user?: UserType | null) {
  return useQuery<string[] | null, Error>(
    ['getHnos', hash(params ?? ''), hash(user ?? '')],
    () => getHnosApiCall(params, user), {
      cacheTime: 3600,
      refetchOnWindowFocus: false,
    },
  );
}
export function UseRemoveHnos(params?:string | null, user?: UserType | null) {
  return useQuery<boolean | null, Error>(
    ['remove', hash(params ?? ''), hash(user ?? '')],
    () => removeHnosApiCall(params, user), {
      cacheTime: 3600,
      refetchOnWindowFocus: false,
    },
  );
}


